<div #chatContent aria-live="polite" class="chatContent" id="chatContent" role="log">
    @for (message of this.comments; track message) {
        <div class="d-flex flex-row mb-10 gap-25">
            @if (message.user.id !== user.id) {
                <a (click)="viewProfile(message.user.id)"
                   (keydown.enter)="viewProfile(message.user.id)"
                   (keydown.space)="$event.preventDefault(); viewProfile(message.user.id)"
                   [attr.aria-label]="user.role.can_access_profiles ? 'View profile of ' + (message.user | nameDisplay) : null"
                   [attr.role]="user.role.can_access_profiles ? 'button' : null"
                   [attr.tabindex]="user.role.can_access_profiles ? 0 : null"
                   [class.clickable]="user.role.can_access_profiles"
                   class="d-flex userPicContainer">
                    @if (message.user.thumbnail || message.user.photo) {
                        <img [alt]="message.user| nameDisplay: undefined: undefined: 'timeline'"
                             [matTooltip]="user.role.can_access_profiles ? 'View ' +  (message.user| nameDisplay: undefined: undefined: 'timeline') + '\'s Profile' : (message.user| nameDisplay: undefined: undefined: 'timeline') + '\'s Profile Picture'"
                             [src]="message.user.thumbnail || message.user.photo || 'assets/images/blankProfile.png'"
                             class="userPic" fetchPriority="low"
                             loading="lazy">
                    }
                    @if (!message.user.thumbnail && !message.user.photo) {
                        <p class="initial m-10">
                            {{ getInitials(message.user| nameDisplay: undefined: undefined: 'timeline') }}
                        </p>
                    }
                </a>
            }
            <div class="d-flex flex-grow flex-col mw-95">
                <div class="talk-bubble p-10">
                    <strong class="primaryContrast f-14">{{ message.user| nameDisplay: undefined: undefined: 'timeline' }}</strong>
                    @if (!message.edit) {
                        <p class="m-0">{{ message.content }}</p>
                        @if (receivedToday(message.date)) {
                            <small class="extraSmall m-5">{{ message.date|date:"HH:mm" }}</small>
                        }
                        @if (!receivedToday(message.date)) {
                            <small class="extraSmall m-5">{{ message.date|date:"dd/MM/yyyy" }}</small>
                        }
                    }
                    @if ("edit" in message && message.edit) {
                        <mat-form-field appearance="outline" class="w-100 bg-textarea-white"
                                        color="primary">
                              <textarea #messageInput [value]="message.content" aria-label="Comment content" matInput
                                        maxlength="400" name="message"></textarea>
                            <mat-hint align="end">{{ messageInput?.value?.length }} / 400</mat-hint>
                        </mat-form-field>
                        <div class="flex-row justify-content-center">
                            <button (click)="editMessage(message, messageInput.value)" color="accent"
                                    mat-raised-button>Save
                            </button>
                        </div>
                    }
                </div>
                @if (message.user.id == user.id || this.user.role.role_type == 'admin') {
                    <div class="flex-row flex-space-around">
                        <button (click)="message.edit = !message.edit" mat-button>
                            @if (!message.edit) {
                                Edit
                            }
                            @if (message.edit) {
                                Cancel
                            }
                        </button>
                        <button (click)="delete(message.id)" color="warn" mat-button>Delete</button>
                    </div>
                }
            </div>
            @if (message.user.id == user.id && !message.edit) {
                <div class="d-flex userPicContainer">
                    @if (message.user.thumbnail || message.user.photo) {
                        <img [alt]="message.user| nameDisplay: undefined: undefined: 'timeline'"
                             [src]="message.user.photo || 'assets/images/blankProfile.png'"
                             class="userPic" fetchPriority="low" loading="lazy"
                             matTooltip="{{message.user| nameDisplay: undefined: undefined: 'timeline'}}">
                    }
                    @if (!message.user.thumbnail && !message.user.photo) {
                        <p class="initial m-10">
                            {{ getInitials(message.user| nameDisplay: undefined: undefined: 'timeline') }}
                        </p>
                    }
                </div>
            }
        </div>
    }
    @if (!reLoading && !endOfChat) {
        <div class="d-flex justify-content-center mb-10">
            <button (click)="loadMore()" (keyup.enter)="loadMore()" class="smallBtn" color="accent" mat-raised-button>
                Load More
            </button>
        </div>
    }
</div>
<mat-card-actions class="mb-0">

    <form [formGroup]="messageForm" class="d-flex flex-row w-100 gap10">
        <div class="flex-auto">
            <mat-form-field appearance="outline" class="w-100"
                            color="primary">
        <textarea #message aria-label="Comment content"
                  formControlName="message" matInput maxlength="400"
                  name="message"></textarea>
                <mat-hint align="end">{{ message?.value?.length }} / 400</mat-hint>
            </mat-form-field>
        </div>
        <div class="flex-col">
            <app-emoji-menu [form]="messageForm" [input]="'message'" matSuffix></app-emoji-menu>
            <button (click)="sendMessage()"
                    [disabled]="!message?.value || this.reLoading"
                    aria-label="Submit Comment"
                    class="ms-auto col-12 text-right"
                    color="primary" mat-icon-button>
                <mat-icon>keyboard_arrow_right</mat-icon>
            </button>
        </div>
    </form>
</mat-card-actions>

@if (reLoading) {
    <mat-card-footer>
        <div [attr.aria-busy]="reLoading" aria-label="Loading comments" aria-valuemax="100" aria-valuemin="0"
             role="progressbar">
            <mat-progress-bar color="primary" mode="indeterminate"></mat-progress-bar>
        </div>
    </mat-card-footer>
}